import { render } from "./VenueDetail.vue?vue&type=template&id=0817308d&scoped=true"
import script from "./VenueDetail.vue?vue&type=script&lang=js"
export * from "./VenueDetail.vue?vue&type=script&lang=js"

import "./VenueDetail.vue?vue&type=style&index=0&id=0817308d&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0817308d"]])

export default __exports__